import {
	$setClientsListRestoreIntent,
	type ClientsListRestoreIntent,
} from '@/entities/clients-filter.entity';
import { buildClientPath, buildClientRouteState } from '@/lib/client-navigation';
import { useUnit } from 'effector-react';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

export function useOpenClient() {
	const navigate = useNavigate();
	const location = useLocation();
	const setRestoreIntent = useUnit($setClientsListRestoreIntent);

	const openClient = useCallback(
		(clientId: string, restore?: ClientsListRestoreIntent) => {
			if (restore) {
				setRestoreIntent(restore);
			}
			navigate(buildClientPath(clientId), {
				state: buildClientRouteState(location.pathname, location.search),
			});
		},
		[location.pathname, location.search, navigate, setRestoreIntent],
	);

	return { openClient };
}
